export default class DescargasHelper {

    static descargarBase64(nombre, datosB64, mime) {
        let downloadLink = document.createElement("a");
        document.body.appendChild(downloadLink);

        let byteCharacters = atob(datosB64);
        let byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) byteNumbers[i] = byteCharacters.charCodeAt(i);
        let byteArray = new Uint8Array(byteNumbers);
        let file = new Blob([byteArray], {type: `${mime};base64`});
        let url = window.URL.createObjectURL(file);

        downloadLink.href = url;
        downloadLink.download = nombre;
        downloadLink.click();

        setTimeout(() => {
            window.URL.revokeObjectURL(url);
            document.body.removeChild(downloadLink);
        }, 0);
    }

    static descargarFicheroEnBinario(nombre, datos, mime) {
        const downloadLink = document.createElement("a");
        document.body.appendChild(downloadLink);

        let byteCharacters = datos;
        let byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) byteNumbers[i] = byteCharacters.charCodeAt(i);
        let byteArray = new Uint8Array(byteNumbers);
        let file = new Blob([byteArray], {type: `${mime};base64`});
        let url = window.URL.createObjectURL(file);

        downloadLink.href = url;
        downloadLink.download = nombre;
        downloadLink.click();

        setTimeout(() => {
            window.URL.revokeObjectURL(url);
            document.body.removeChild(downloadLink);
        }, 0);

    }

    static descargarCSVUTF8(nombre, datos, mime) {
        const uriContent = `data:${mime},` + encodeURIComponent(datos);
        const element = document.createElement('a');
        element.setAttribute('href', uriContent);
        element.setAttribute('download', nombre);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }
}